import React from "react";
import { useQuickSightHealthEvents } from "@/hooks/useHealthEvents";

const QuickSightAwsHealthDashboard = () => {
  const { embedUrl, loading, error } = useQuickSightHealthEvents();

  return (
    <div className="quicksight-container">
      <iframe
        title="QuickSight Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default QuickSightAwsHealthDashboard;
